import React from 'react';
import PublicLayout from '../components/PublicLayout';
import AboutGrid from '../components/AboutGrid';
const h=React.createElement;
export default function About(props) {
  return h(PublicLayout,{page:'about',isLoggedIn:props.isLoggedIn},
    h(AboutGrid,{isLoggedIn:props.isLoggedIn}));
}

